module.exports = __webpack_public_path__ + "img/dining_room_full.9477a27f.jpg";